import { observer } from 'mobx-react-lite';
import React from 'react';
import { AppProps } from './App';
import { toggleNavigationMenu } from '../stores/styleStore';
import FileMenu from './FileMenu';
import LoadingListItem from './LoadingListItem';
import { action } from 'mobx';

const Navigation = observer((props: AppProps) => {
    const {state, styles} = props;
    return (
        <div className={styles.get('navigation.nav-menu').classNames}>
            <div className="flex-mother p-7px">
                <a href="https://goldfynch.com"><img className="h-3em" src="https://goldfynch.com/img/logo_square.png" alt="Logo for GoldFynch eDiscovery"/></a>
                <div className="flex-mother-col flex-1">
                    <div className="flex-1" />
                    <span className="textHeader nav-accent flex-1">MBOX Viewer </span>
                    <div className="flex-1" />
                </div>
                <div className="flex-mother-col">
                    <div className="flex-1" />
                    <button className="navbarButton-half" onClick={e => toggleNavigationMenu(styles)}><i className="arrow-left" /></button>
                    <div className="flex-1" />
                </div>
            </div>
            <div className="line-90percent h-5px" />
            <div id="navigationMenuChildren">
                {state.mboxList.map((val, ix) => {
                    return <FileMenu state={state} styles={styles} currentFileIx={ix}/>;
                })}
                {state.loadingListElements.map((val, ix) => {
                    return <LoadingListItem
                                state={state}
                                name={state.loadingListElements[ix].name}
                                numberOfEmails={state.loadingListElements[ix].loadedEmailCount}
                                eject={action(() => {
                                    if(state.cancellationFunctions[state.loadingListElements[ix].cancelIx] !== undefined) {
                                        state.cancellationFunctions[state.loadingListElements[ix].cancelIx]!();
                                    }
                                    // This removes an element from the mboxList array in place.
                                    state.loadingListElements.splice(ix, 1);
                                })} 
                                styles={styles}
                            />;
                })}
            </div>
        </div>
    );
});

export default Navigation;